import { HasCartContext, withCart } from "@insite/client-framework/Components/CartContext";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import Typography from "@insite/mobius/Typography";
import Link from "@waytek/MobiusOverrides/Link/Link";
import Tooltip from "@waytek/MobiusOverrides/Tooltip/Tooltip";
import { CartLineCardCondensedStyles } from "@waytek/Overrides/Widgets/Cart/CartLineCardCondensed";
import { CartLineCardExpandedStyles } from "@waytek/Overrides/Widgets/Cart/CartLineCardExpanded";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    modalOpenHandler: () => void;
    minOrderSubtotal?: number;
    styles?: CartLineCardExpandedStyles | CartLineCardCondensedStyles;
    hasShipments?: boolean;
    removeShipments?: () => void;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    isGuest: state.context.session?.isGuest || !state.context.session.isAuthenticated,
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    location: getLocation(state),
    currentCart: getCurrentCartState(state).value,
});

const mapDispatchToProps = {};

export type Props = OwnProps &
    HasCartLineContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasCartContext;

const ScheduleShipmentRenderComponent = ({
    cart,
    modalOpenHandler,
    minOrderSubtotal,
    styles,
    cartLine,
    isGuest,
    signInUrl,
    location,
    currentCart,
    hasShipments = false,
    removeShipments = () => {},
}: Props) => {
    const cartValue = cart || currentCart;
    if (cartValue?.orderGrandTotal == null || minOrderSubtotal == null) {
        return (
            <>
                <Typography {...styles?.schedulesShipmentLink?.typographyProps}>
                    {translate("Schedule Shipment")}
                </Typography>

                {minOrderSubtotal != null && (
                    <Tooltip
                        {...styles?.tooltip}
                        text={siteMessage("Cart_ScheduleShipment_TooltipMessage").toString()}
                        content={siteMessage(
                            "Cart_ScheduleShipment_TooltipMessage",
                            `${minOrderSubtotal}`,
                            `${signInUrl}?returnUrl=${encodeURIComponent(location.pathname + location.search)}`,
                        )}
                        bodyTextAlign="left"
                    />
                )}
            </>
        );
    }

    return (
        <>
            {cartValue?.orderGrandTotal <= +minOrderSubtotal && (
                <Typography {...styles?.schedulesShipmentLink?.typographyProps}>
                    {translate("Schedule Shipment")}
                </Typography>
            )}

            {cartValue?.orderGrandTotal > +minOrderSubtotal && (
                <Link {...styles?.schedulesShipmentLink} onClick={modalOpenHandler}>
                    {translate("Schedule Shipment")}
                </Link>
            )}

            <Tooltip
                {...styles?.tooltip}
                text={siteMessage("Cart_ScheduleShipment_TooltipMessage").toString()}
                content={
                    isGuest
                        ? siteMessage(
                              "Cart_ScheduleShipment_TooltipMessage",
                              `${minOrderSubtotal}`,
                              `${signInUrl}?returnUrl=${encodeURIComponent(location.pathname + location.search)}`,
                          )
                        : siteMessage("Cart_ScheduleShipment_TooltipMessageNoLogin", `${minOrderSubtotal}`)
                }
                bodyTextAlign="left"
            />

            {hasShipments && (
                <Link {...styles?.schedulesShipmentLink} onClick={removeShipments}>
                    {translate("Clear shipments")}
                </Link>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withCart(withCartLine(ScheduleShipmentRenderComponent)));
